import { render, staticRenderFns } from "./media-library.vue?vue&type=template&id=541709b4&"
import script from "./media-library.vue?vue&type=script&lang=js&"
export * from "./media-library.vue?vue&type=script&lang=js&"
import style0 from "./media-library.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports